import { render, staticRenderFns } from "./DateRangeExt.vue?vue&type=template&id=315e8abc&scoped=true&"
import script from "./DateRangeExt.vue?vue&type=script&lang=js&"
export * from "./DateRangeExt.vue?vue&type=script&lang=js&"
import style0 from "./DateRangeExt.vue?vue&type=style&index=0&id=315e8abc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315e8abc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('315e8abc')) {
      api.createRecord('315e8abc', component.options)
    } else {
      api.reload('315e8abc', component.options)
    }
    module.hot.accept("./DateRangeExt.vue?vue&type=template&id=315e8abc&scoped=true&", function () {
      api.rerender('315e8abc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2w36wPP5Uv3xG/JS/comp/DateRangeExt.vue"
export default component.exports